import React from "react";
import styled from "styled-components";
import { font, theme } from "styles";

type Props = {
  children: string;
  isDisabled?: boolean;
  onClick: () => void;
};

export const ReactionListAddButton = ({ children, isDisabled = false, onClick }: Props) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onClick();
  };

  return (
    <StyledButton disabled={isDisabled} onClick={handleClick}>
      <StyledButtonLabel>{`+ ${children}`}</StyledButtonLabel>
    </StyledButton>
  );
};

/**
 * Styles
 */

const StyledButtonLabel = styled("span")`
  position: relative;
  font-size: 12px;
  font-weight: ${font.weight.medium};
  color: ${theme.reactionListAddButton.fontColor};
`;

const StyledButton = styled("button")`
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  padding: 5px;
  border: none;
  border-radius: 5px;
  margin: 6px 0 0 0;
  text-decoration: none;
  cursor: pointer;

  &:hover ${StyledButtonLabel} {
    color: ${theme.buttonLink.fontColor.hover};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 5px ${theme.buttonLink.outlineColor};

    & ${StyledButtonLabel} {
      color: ${theme.buttonLink.fontColor.focus};
    }
  }

  &:active ${StyledButtonLabel} {
    color: ${theme.buttonLink.fontColor.active};
  }

  &:disabled {
    cursor: not-allowed;

    & ${StyledButtonLabel} {
      color: ${theme.buttonLink.fontColor.disabled};
    }
  }
`;
